import { useEffect, useRef, useState } from "react";

const FACTS = [
  { value: 120163, display: "120,163", text: "NYC private water service lines identified as containing lead.", source: "NYC GOV" },
  { value: 123758, display: "123,758", text: "Additional NYC private service lines listed as having unknown material.", source: "NYC GOV" },
  { value: 190, display: "190% HIGHER", suffix: "% HIGHER", text: "Nitrogen dioxide measured during cooking in gas-stove apartments versus induction apartments in an NYC pilot.", source: "WE ACT · NYC" },
];

const ROTATE_MS = 4500;
const COUNT_MS = 700;
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

const useCountUp = (target, key) => {
  const [n, setN] = useState(target);
  useEffect(() => {
    if (reduced()) { setN(target); return; }
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / COUNT_MS, 1);
      setN(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, key]);
  return n;
};

const Value = ({ fact, k }) => {
  const n = useCountUp(fact.value, k);
  return (
    <span className="font-mono text-2xl sm:text-[17px] font-medium text-forest tabular-nums whitespace-nowrap leading-none" data-testid="evidence-value">
      {n.toLocaleString()}{fact.suffix || ""}
    </span>
  );
};

export const EvidenceTicker = () => {
  const [i, setI] = useState(0);
  const [visible, setVisible] = useState(true);
  const timer = useRef();

  useEffect(() => {
    const advance = () => {
      if (reduced()) { setI((v) => (v + 1) % FACTS.length); return; }
      setVisible(false);
      timer.current = setTimeout(() => { setI((v) => (v + 1) % FACTS.length); setVisible(true); }, 260);
    };
    const id = setInterval(advance, ROTATE_MS);
    return () => { clearInterval(id); clearTimeout(timer.current); };
  }, []);

  const f = FACTS[i];
  return (
    <div className="border-b border-divider pb-4 sm:pb-3" data-testid="evidence-ticker" aria-live="polite" aria-atomic="true">
      <p className="mono uppercase tracking-[0.18em] text-sec">Measured in New York</p>
      <div
        key={i}
        className="mt-2.5 sm:mt-2 flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-3 min-h-[88px] sm:min-h-[26px]"
        style={reduced() ? undefined : { opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(7px)", transition: "opacity 260ms ease, transform 260ms ease" }}
      >
        <Value fact={f} k={i} />
        <span className="hidden sm:inline text-sec" aria-hidden>—</span>
        <span className="text-[15px] sm:text-sm leading-snug text-ink max-w-md" data-testid="evidence-text">{f.text}</span>
        <span className="mono text-[10px] tracking-[0.12em] text-sec sm:ml-1 whitespace-nowrap rounded border border-divider px-1.5 py-0.5 self-start sm:border-0 sm:px-0 sm:py-0" data-testid="evidence-source">{f.source}</span>
      </div>
    </div>
  );
};
